import { Reveal } from "./Reveal";
import { RefreshCcw, ShieldCheck, MonitorSmartphone, HeartHandshake, TrendingUp } from "lucide-react";

export function Benefits({ images }) {
  return (
    <section id="benefits" className="py-20 md:py-28" data-testid="benefits-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FF6B4A] mb-4">Why Dogtopia</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0D3B3E] max-w-2xl">
            A business model designed for recurring revenue — and a life you love
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-12 gap-5">
          <Reveal className="md:col-span-8">
            <div className="h-full bg-[#0D3B3E] rounded-3xl p-8 md:p-10 text-white relative overflow-hidden">
              <RefreshCcw className="w-10 h-10 text-[#F7C948] mb-6" />
              <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight mb-3">Recurring Membership Revenue</h3>
              <p className="text-white/75 leading-relaxed max-w-md">
                Wellness memberships drive predictable, subscription-style monthly income. Members visit more often,
                stay longer, and form the backbone of a resilient daycare business.
              </p>
              <div className="absolute -right-10 -bottom-10 w-48 h-48 rounded-full bg-[#FF6B4A]/15" />
              <div className="absolute right-16 -top-8 w-24 h-24 rounded-full bg-[#F7C948]/15" />
            </div>
          </Reveal>

          <Reveal delay={0.1} className="md:col-span-4">
            <div className="h-full rounded-3xl overflow-hidden border border-[#E4DFD3] relative min-h-[260px]">
              <img src={images.playroom} alt="Dogs playing in a Dogtopia playroom" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D3B3E]/70 to-transparent" />
              <div className="absolute bottom-5 left-5 text-white">
                <div className="font-display font-bold text-lg">Open-Play Daycare</div>
                <div className="text-white/75 text-sm">The heart of every location</div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="md:col-span-4">
            <div className="h-full bg-white rounded-3xl p-8 border border-[#E4DFD3]">
              <TrendingUp className="w-9 h-9 text-[#FF6B4A] mb-5" />
              <h3 className="font-display text-lg font-semibold text-[#0D3B3E] mb-2">$165B Recession-Resilient Market</h3>
              <p className="text-sm text-[#5C6B6C] leading-relaxed">
                Pet spending has grown through every economic cycle. Dogs are family — and families don't cut back on family.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="md:col-span-4">
            <div className="h-full bg-white rounded-3xl p-8 border border-[#E4DFD3]">
              <HeartHandshake className="w-9 h-9 text-[#FF6B4A] mb-5" />
              <h3 className="font-display text-lg font-semibold text-[#0D3B3E] mb-2">Comprehensive Support System</h3>
              <p className="text-sm text-[#5C6B6C] leading-relaxed">
                Real estate, construction, marketing, and 6 weeks of Dogtopia University training — you're never building alone.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="md:col-span-4">
            <div className="h-full bg-white rounded-3xl p-8 border border-[#E4DFD3]">
              <MonitorSmartphone className="w-9 h-9 text-[#FF6B4A] mb-5" />
              <h3 className="font-display text-lg font-semibold text-[#0D3B3E] mb-2">Tech & Live Webcams</h3>
              <p className="text-sm text-[#5C6B6C] leading-relaxed">
                Proprietary software and live playroom webcams keep pet parents connected — and keep them coming back.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2} className="md:col-span-12">
            <div className="bg-[#F3EFE6] rounded-3xl px-8 md:px-10 py-8 border border-[#E4DFD3] flex flex-col md:flex-row items-start md:items-center gap-6">
              <ShieldCheck className="w-10 h-10 text-[#0D3B3E] shrink-0" />
              <div>
                <h3 className="font-display text-lg font-semibold text-[#0D3B3E] mb-1">Proprietary Safety Standards</h3>
                <p className="text-sm text-[#5C6B6C] leading-relaxed max-w-3xl">
                  Certified Canine Coaches, rigorous health protocols, and industry-leading safety systems protect every dog
                  in our care — the trust foundation the entire brand is built on.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
